import useTestId from '@ori/testid-generator';
import { useCallback, type FC, useState } from 'react';

import { useTopAreaBanner } from '../../../../context';
import { useTranslations } from '../../../../hooks/useTranslations';
import { OrderOnBehalf } from '../../../OrderOnBehalf';
import { TOP_AREA_BANNER_BENEFIT_BANNER } from '../../constants';
import { Root } from '../../styles';
import { TopAreaBannerDialog } from '../TopAreaBannerDialog';
import { goToPage } from './goToPage';
import { Title } from './styles';

export const TopAreaBannerContent: FC = () => {
  const { getTestId } = useTestId();
  const { benefitBannerData, isAnonymousWithStore, isOrderOnBehalfVisible } = useTopAreaBanner();
  const { translations } = useTranslations();
  const [open, setOpen] = useState(false);
  const onClose = useCallback(() => setOpen(false), []);
  const onTopAreaBannerClick = useCallback(() => {
    if (isAnonymousWithStore) {
      setOpen(true);
    } else if (benefitBannerData?.messageUrl) {
      goToPage(benefitBannerData.messageUrl);
    }
  }, [benefitBannerData?.messageUrl, isAnonymousWithStore]);

  if (isOrderOnBehalfVisible) {
    return (
      <Root isOrderOnBehalfVisible>
        <OrderOnBehalf />
      </Root>
    );
  }

  return (
    <>
      <Root
        data-testid={getTestId(TOP_AREA_BANNER_BENEFIT_BANNER)}
        onClick={onTopAreaBannerClick}
      >
        <Title variant="body1">
          {isAnonymousWithStore ? translations.topAreaBannerReferralMessage : benefitBannerData?.messageTitle}
        </Title>
      </Root>
      <TopAreaBannerDialog
        open={open}
        onClose={onClose}
      />
    </>
  );
};
